import { computed } from 'vue';
import search from '@/libs/search';

export const usePagination = (params) => {
    const { tableSearch, tableLoad } = params;

    const total = computed(() => {
        return (((tableSearch.value || {}).limit || {}).conditions || {}).total || 0;
    });

    const pageSize = computed(() => {
        return (((tableSearch.value || {}).limit || {}).conditions || {}).pageLength || 10;
    });

    const current = computed(() => {
        return (((tableSearch.value || {}).limit || {}).conditions || {}).pageStart || 1;
    });

    const onPageChange = (pageIndex) => {
        search.globalPageOnChange(tableSearch.value, pageIndex);
        tableLoad();
    };

    const onPageSizeChange = (size) => {
        search.globalSizeOnChange(tableSearch.value, size);
        tableLoad();
    };

    const reset = () => {
        search.globalResetSearch(tableSearch.value);
        tableLoad();
    };

    return {
        total,
        pageSize,
        current,
        onPageChange,
        onPageSizeChange,
        reset
    };
};

